import React from 'react';
import { Clock, Users, BookOpen, Calendar, Newspaper, Shield, GitBranch, Briefcase, Repeat } from 'lucide-react';
import { getRoleBadgeClass } from './shared';

const MONTH_NAMES = ['Jan','Feb','Mrz','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'];

const MonthGrowthChart = ({ items, testId }) => {
  const monthData = {};
  items.forEach(it => {
    if (it.created_at) {
      const d = new Date(it.created_at);
      const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      monthData[key] = (monthData[key] || 0) + 1;
    }
  });
  const sortedMonths = Object.keys(monthData).sort();
  const maxVal = Math.max(...Object.values(monthData), 1);
  return (
    <div className="growth-chart" data-testid={testId}>
      {sortedMonths.map(m => {
        const [y, mo] = m.split('-');
        const label = `${MONTH_NAMES[parseInt(mo)-1]} ${y}`;
        const pct = (monthData[m] / maxVal) * 100;
        return (
          <div key={m} className="growth-bar-wrap">
            <div className="growth-bar" style={{height: `${Math.max(pct, 8)}%`}}>
              <span className="growth-bar-value">{monthData[m]}</span>
            </div>
            <span className="growth-bar-label">{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default function DashboardTab({ user, pending, downline, courses, upcomingEvents, news, projects, allUsers, isAdminOrCoach, rotatorLeads = [] }) {
  return (
    <div className="tab-content" data-testid="dashboard-content">
      <div className="section-card"><h3>Willkommen, {user?.first_name}!</h3><p>Nutze die Tabs oben, um auf Kurse, Kalender, News und mehr zuzugreifen.</p></div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-icon pending"><Clock size={22} /></div><div className="stat-info"><span className="stat-value">{pending.length}</span><span className="stat-label">Ausstehende Freigaben</span></div></div>
        <div className="stat-card"><div className="stat-icon success"><Users size={22} /></div><div className="stat-info"><span className="stat-value">{downline.length}</span><span className="stat-label">Downline</span></div></div>
        <div className="stat-card"><div className="stat-icon info"><BookOpen size={22} /></div><div className="stat-info"><span className="stat-value">{courses.length}</span><span className="stat-label">Kurse</span></div></div>
        <div className="stat-card"><div className="stat-icon warning"><Calendar size={22} /></div><div className="stat-info"><span className="stat-value">{upcomingEvents.length}</span><span className="stat-label">Events</span></div></div>
        <div className="stat-card"><div className="stat-icon" style={{background: 'rgba(200,164,92,0.1)'}}><Newspaper size={22} style={{color: '#C8A45C'}} /></div><div className="stat-info"><span className="stat-value">{news.length}</span><span className="stat-label">News-Beitraege</span></div></div>
      </div>

      {projects.length > 0 && (
        <div className="section-card">
          <h3><Briefcase size={18} /> Projekte – Meine Downline</h3>
          <div className="stats-grid">
            {projects.map(p => {
              const myCount = downline.filter(d => d.project_ids && d.project_ids[p.id]).length;
              return (
                <div key={p.id} className="stat-card">
                  <div className="stat-icon" style={{background: 'rgba(200,164,92,0.1)'}}><Briefcase size={22} style={{color: '#C8A45C'}} /></div>
                  <div className="stat-info"><span className="stat-value">{myCount}</span><span className="stat-label">{p.name}</span></div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {isAdminOrCoach && (
        <div className="section-card">
          <h3><Shield size={18} /> Plattform-Statistiken</h3>
          <div className="stats-grid">
            <div className="stat-card"><div className="stat-icon success"><Users size={22} /></div><div className="stat-info"><span className="stat-value">{allUsers.filter(u => u.status === 'active').length}</span><span className="stat-label">Aktive Freigeister gesamt</span></div></div>
            <div className="stat-card" data-testid="rotator-total-stat"><div className="stat-icon" style={{background: 'rgba(200,164,92,0.1)'}}><Repeat size={22} style={{color: '#C8A45C'}} /></div><div className="stat-info"><span className="stat-value">{rotatorLeads.length}</span><span className="stat-label">Rotator-Anfragen gesamt</span></div></div>
            {projects.map(p => {
              const totalCount = allUsers.filter(u => u.project_ids && u.project_ids[p.id]).length;
              return (
                <div key={p.id} className="stat-card">
                  <div className="stat-icon" style={{background: 'rgba(200,164,92,0.1)'}}><Briefcase size={22} style={{color: '#C8A45C'}} /></div>
                  <div className="stat-info"><span className="stat-value">{totalCount}</span><span className="stat-label">{p.name} (gesamt)</span></div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {isAdminOrCoach && allUsers.length > 0 && (
        <div className="section-card">
          <h3><GitBranch size={18} /> User-Wachstum pro Monat</h3>
          <MonthGrowthChart items={allUsers} testId="growth-chart" />
        </div>
      )}

      {isAdminOrCoach && rotatorLeads.length > 0 && (
        <div className="section-card">
          <h3><Repeat size={18} /> Rotator-Anfragen pro Monat</h3>
          <MonthGrowthChart items={rotatorLeads} testId="rotator-growth-chart" />
        </div>
      )}
    </div>
  );
}
